import LLTrendingNow from '@/locales/TrendingNow/fr';
import LLEdito from '@/locales/Edito/fr';
import LLTravel from '@/locales/Travel/fr';
import LLFuture from '@/locales/Future/fr';
import LLArty_Paris from '@/locales/Arty_Paris/fr';
import LLArty_Digital from '@/locales/Arty_Digital/fr';
import LLKeyReport from '@/locales/KeyReport/fr';
import LLPioneer_MartinRoland from '@/locales/Pioneer_MartinRoland/fr';
import LLPioneer_Chassard from '@/locales/Pioneer_Chassard/fr';
import LLBack from '@/locales/Back/fr';
import LLProfiting from '@/locales/Profiting/fr';
import LLLegal from '@/locales/Legal/fr';

export const  fr = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        EditoCH: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoFR: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoLU: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoMC: {
            segment: 'edito',
            title: 'Édito',
        },
        TrendingNow: {
            segment: 'tendances',
            title: 'Carnet de tendances',
        },
        Travel: {
            segment: 'kent-etonnant-jardin-angleterre',
            title: 'Kent, l’étonnant jardin de l’Angleterre',
        },
        Future: {
            segment: 'reinventer-materiaux-batir-demain',
            title: 'Réinventer les matériaux pour bâtir demain',
        },
        Arty_Paris: {
            segment: 'paris-art-contemporain-renaissance',
            title: 'Paris et l’art contemporain, une renaissance ?',
        },
        Arty_Digital: {
            segment: 'art-digital',
            title: 'Qu’est-ce que l’art digital ?',
        },
        KeyReport: {
            segment: 'forets-heure-changement-climatique',
            title: `Les forêts à l’heure du changement climatique`,
        },
        Pioneer_MartinRoland: {
            segment: 'philanthropie-art-apprivoiser-temps',
            title: 'La philanthropie ou l’art d’apprivoiser le temps',
        },
        Pioneer_Chassard: {
            segment: 'maelle-chassard-conteuse-hors-pair',
            title: `Maëlle Chassard, conteuse hors pair`,
        },
        Back: {
            segment: 'renaissance-polaroid',
            title: 'Il y a 12 ans, la renaissance du Polaroid',
        },
        Profiting: {
            segment: 'beaute-durable-engagee',
            title: 'La beauté durable et engagée',
        },
        Legal: {
            segment: 'credits-informations-legales',
            title: 'Crédits & informations légales',
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    EditoCH: LLEdito,
    EditoFR: LLEdito,
    EditoLU: LLEdito,
    EditoMC: LLEdito,

    TrendingNow: LLTrendingNow,

    Travel: LLTravel,

    Future: LLFuture,

    Arty_Paris: LLArty_Paris,

    Arty_Digital: LLArty_Digital,

    KeyReport: LLKeyReport,

    Pioneer_MartinRoland: LLPioneer_MartinRoland,

    Pioneer_Chassard: LLPioneer_Chassard,

    Back: LLBack,

    Profiting: LLProfiting,

    Legal: LLLegal,

    home: {
        logoBaseLine: 'Pour un monde plus&nbsp;engagé <br/>avec Société&nbsp;Générale Private&nbsp;Banking ',
        logoDate: 'Hiver 2023 #9',
        title: `Les forêts à l'heure du changement climatique`,
        artitle1title: `Réinventer les matériaux <br/>pour bâtir demain`,
        artitle2title: `Maëlle Chassard, <br/>conteuse hors pair`,
        artitle3title: `Qu’est-ce que l’art numérique ?`,
    },

    next: 'À suivre : ',

    welcome_message : 'FR - Welcome to Your Vue.js App',
    popular_links : 'FR - Popular Links',
    ecosystem : 'FR - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: '&nbsp;',
    counterUpDecimal: ',',
};
